$(frappe).ready(() => {
	const logged_in = frappe.is_user_logged_in();
	console.log("logged_in", logged_in, $(".custom-login-navbar-actions"));
	$(".custom-login-navbar-actions").toggleClass("hide", logged_in ? true : false);
	const roles = frappe.user_roles
	console.log("roles", roles);
})